import React from "react"
import { useState, useEffect } from "react"
import { Input } from "@progress/kendo-react-inputs";
import { alertService } from '../../services/helpers/alert.service';
import { CustomUpload } from "../shared/customUpload";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";


export const AddFileDialog = (props) => {
    const toggleDialog = props.toggleDialog;
    const [file, setFile] = useState();
    const [description, setDescription] = useState("");


    const handleFileLoad = (event) => {
        setFile(event.value);
    }

    useEffect(() => {

    }, []);

    const handleSubmit = async (event) => {

        event.preventDefault();

        if (!description) {
            alertService.error("Campul descriere este obligatoriu!");
            return;
        }

        if (!file || file.length == 0) {
            alertService.error("Nu ati selectat nici un fisier!");
            return;
        }
        /*
          Denumire si nume fisier sunt folosite pentru a pastra compatibilitatea
        */

        props.addFile({
            nume: file[0].name,
            denumire: file[0].name,
            numeFisier: file[0].name,
            descriere: description,
            dimensiune: file[0].size,
            rawFile: file[0].getRawFile()
        });
        props.toggleDialog();
    }


    return (
        <>
            <Dialog title={"Adauga fisier"} onClose={toggleDialog}>

                <h2 className="titlu">Adauga fisier</h2>
                <div name="div_date">
                    <form className="formular" name="form_file" onSubmit={handleSubmit} >
                        <fieldset>
                            <div className="clearfix pb10">
                                <label className="pb5">Descriere fisier:</label>
                                <Input name="descriere"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>

                            <div className="clearfix pb10">
                                <label className="pb5">Fisier:</label>
                                <CustomUpload
                                    value={file}
                                    onChange={handleFileLoad}
                                />
                            </div>


                        </fieldset>
                    </form>

                </div>

                <DialogActionsBar>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={handleSubmit}
                    >
                        Adauga Fisier
                    </button>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={props.toggleDialog}
                    >
                        Inchide
                    </button>
                </DialogActionsBar>
            </Dialog>
        </>
    );
}